import Vue from "vue";
import VeeValidate from "vee-validate";
import VueI18n from "vue-i18n";

import App from "@/App";
import router from "@/router";
import store from "@/store";
import messages from "@/lang/";

// Plugins
import Util from "@/lib/util";
import Filter from "@/lib/filter";
import Message from "@/lib/message";
import Modal from "@/lib/modal";
import Service from "@/lib/service";
import Storage from "@/lib/storage";
import Loading from "@/components/plugins/loading/loading";
import serviceOidc from "@/lib/service.oidc";

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

// Development bypass: inject hardcoded auth tokens so local dev can skip OIDC
if (process.env.AUTH_BYPASS === 'true') {
  const authData = {
    access_token: 'w696PNrk7N9fpnHVe0SJS9dr2P7t2pNTkjlWc6D9lgW',
    expires_in: 7200,
    id_token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InIxTGtiQm8zOTI1UmIyWkZGckt5VTNNVmV4OVQyODE3S3gwdmJpNmlfS2MifQ.eyJzdWIiOiJhZGM4NjBjZC0wOTIwLTQ3ZmMtYTA0Mi04MDg5N2U0ZmQxM2YiLCJhdXRoX3RpbWUiOjE3Njc5NzYxMzgsIm5vbmNlIjoiZDdjYmY5MGQ0NDAwMzJlOTRmYTU0MDQ5NDcwNTM2ZDk0ZDQ0NzI0NmMwMDVmZGQ3YjZjY2UzNTJmMGJlNTBlYzY0MjE2Yjg2NmJhZjY0YWI0OWI2M2Y1MGU4ZTkxOTM0OGJjZmY1OWY3MDY3M2VhZmVhNmEyMTYxZGY4NWVjYzMiLCJhdF9oYXNoIjoiaXYyLTZJdWJyNVYyZVFqWUFVMW41ZyIsImF1ZCI6IkQ0UHFLcExfV0s2cnRfY093aUEwbiIsImV4cCI6MTc2Nzk5MDUzOSwiaWF0IjoxNzY3OTc2MTM5LCJpc3MiOiJodHRwczovL3Byb3ZlZWRvci5jaXVkYWRhbmlhZGlnaXRhbC5ibyJ9.iqH11Nga7CP3fKhJEWjmAJEg5xLbKJi6IsfVVTbtimfwU6Hssf0Sb7vmIwzcVsojmRDs2AphiH-68Pjg1mMW1TlWVg6ueZDQKjNeRLs0v2DzxRUmqydxTu_BNEwrJg0hHsZDXVECray8MH21znS_Hweq84FIN-pp2eFdo8PalbREC5Jz5ZkYvzprH4BgVaqxnvF_Nsvc7KYMEnK3eeJNauM_3iaYe4RpVQzm3qozoEee9fTovy5I_qcN1ehVq-diqrEjs8ARJ4zLzAaLBHM6kGRRSs3hNl_gHb0pbpeCCTjnKNfmCCAMVY4xQBTR3m4RkJnC4S1HsQZphtIa-jUSXA',
    scope: 'profile openid email celular fecha_nacimiento',
    token_type: 'Bearer'
  };

  sessionStorage.setItem('legalizacion-web_access_token', JSON.stringify(authData.access_token));
  sessionStorage.setItem('access_token', authData.access_token);
  sessionStorage.setItem('id_token', authData.id_token);
  sessionStorage.setItem('token_type', authData.token_type);
  sessionStorage.setItem('expires_in', authData.expires_in);
  sessionStorage.setItem('legalizacion-web_expires_at', JSON.stringify(Date.now() + authData.expires_in * 1000));
  sessionStorage.setItem('scope', authData.scope);
  localStorage.setItem('legalizacion-web_access_token', JSON.stringify(authData.access_token));

  // eslint-disable-next-line no-console
  console.log('AUTH BYPASS: tokens injected');
}
// i18n config
Vue.component("v-select", vSelect);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "es",
  messages
});

Vue.use(Storage, { appName: "legalizacion-web" });
Vue.use(VeeValidate);
Vue.use(Util);
Vue.use(Filter);
Vue.use(Message);
Vue.use(Modal);
Vue.use(Loading);

Vue.use(Service, {
  apiUrl: process.env.API_URL
});

Vue.use(serviceOidc, {
  Issuer: process.env.OIDC_ISSUER,
  ClientId: process.env.OIDC_CLIENT_ID,
  ClientSecret: process.env.OIDC_CLIENT_SECRET,
  Scope: process.env.OIDC_SCOPE,
  RedirectUri: process.env.OIDC_REDIRECT_URI,
  PostLogoutRedirectUri: process.env.OIDC_POST_LOGOUT_REDIRECT_URI,
  ResponseType: process.env.ODIC_RESPONSE_TYPE
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  template: "<App/>",
  serviceOidc,
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js